import CodeMirror from "@uiw/react-codemirror";
import { githubLight } from "@uiw/codemirror-theme-github";
import { json } from "@codemirror/lang-json";
import { Button } from "antd";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthCtx";

const EditorArea = ({ onUpdate }) => {
  return (
    <>
      <div className="editor-section">
        <CodeMirror
          theme={githubLight}
          onChange={(v, vu) => onUpdate(v)}
          style={{ fontFamily: "monospace" }}
          extensions={[json({})]}
        />
      </div>
    </>
  );
};

const ChatArea = ({ handleAsk, loading }) => {
  const inputRef = useRef(null);
  const answerTypeRef = useRef(null);
  const authCtx = useAuth();
  const handleSend = (e) => {
    handleAsk(inputRef.current.innerText, answerTypeRef.current.value);
  };
  return (
    <>
      <div className="chat-section">
        <div className="chat-preview">
          {loading ? (
            <div className="chat-list">
              <div className="chat-content">
                <h3 style={{ textAlign: "center" }}>Please wait...</h3>
              </div>
            </div>
          ) : (
            <>
              {authCtx.conversation ? (
                <>
                  {authCtx.conversation.error ? (
                    <>
                      <div className="chat-list">
                        <div className="chat-content">
                          <h3 style={{ textAlign: "center" }}>
                            Error please try again.
                          </h3>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="chat-list">
                        <div className="chat-content outgoing">
                          <div className="toolbar">
                            <span className="author">you</span>
                          </div>
                          <p>{authCtx.conversation.question}</p>
                        </div>
                      </div>
                      <div className="chat-list">
                        <div className="chat-content incoming">
                          <div className="toolbar">
                            <span className="author">{`guruji${
                              authCtx.conversation.answers[
                                Object.keys(authCtx.conversation.answers)[0]
                              ].success_prediction
                                ? ": type verified"
                                : ""
                            }`}</span>
                          </div>
                          <p>
                            {
                              authCtx.conversation.answers[
                                Object.keys(authCtx.conversation.answers)[0]
                              ].val
                            }
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="chat-list">
                    <div className="chat-content">
                      <h3 style={{ textAlign: "center" }}>
                        Put the data and Ask the question in your preferred
                        type.
                      </h3>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className="chat-input">
          <div className="inner">
            <div className="inputbox">
              <div
                ref={inputRef}
                contentEditable={true}
                className="input-control"
              ></div>
              <div className="sendbtn">
                <Button
                  onClick={handleSend}
                  type="primary"
                  shape="round"
                  loading={loading}
                  icon={<span>SEND</span>}
                  size="middle"
                />
              </div>
            </div>
            <div className="advanced_panel">
              <div className="inner">
                <div className="section">
                  <div className="opt-option">
                    <span>ANSWER Type</span>
                    <select
                      defaultValue={"any"}
                      ref={answerTypeRef}
                      id="answer_type"
                    >
                      <option value={"number"}>Number</option>
                      <option value={"word"}>1 Word</option>
                      <option value={"sentence"}>Sentence</option>
                      <option value={"any"}>Any</option>
                    </select>
                  </div>
                </div>
                <div className="section">
                  <button className="button-sm">Get API code</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default function GurujiMainApp({ children }) {
  const data = useRef(null);
  const [loading, setLoading] = useState(false);
  const authCtx = useAuth();

  const handleAsk = (qvalue, answertype) => {
    if(data.current.length > 0) {
      setLoading(true);
      authCtx.askApi(data.current, qvalue, answertype);  
    }
  };

  useEffect(() => {
    if (authCtx.conversation) {
      setLoading(false);
    }
  }, [authCtx.conversation]);

  return (
    <div className="body-p">
      <div className="section">
        <div className="sec-hdr">
          <span>PUT ANY DATA</span>
        </div>
        <EditorArea onUpdate={(text) => (data.current = text)} />
      </div>
      <div className="section">
        <div className="sec-hdr">
          <span>CHAT</span>
        </div>
        <ChatArea handleAsk={handleAsk} loading={loading} />
      </div>
    </div>
  );
}
